export const formatCpr = (value?: string, missingValue = '') => {
  if (!value) return missingValue;

  if (value.length === 10) {
    return `${value.substr(0, value.length - 4)}-${value.slice(-4)}`;
  }

  return value;
};

export const formatCprNoDash = (cpr: string) => cpr.replace('-', '');

export const isValidCpr = (value: string) => {
  const regex = /^(\d{10}|\d{6}-\d{4})$/;
  return regex.test(value);
};

// Formats a CPR while it is typed: only digits, at most ten, and the dash once the digits after it are typed.
export const formatCprWhileTyping = (value: string) => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  return digits.length > 6 ? `${digits.slice(0, 6)}-${digits.slice(6)}` : digits;
};
